import { BaseUrl } from '../../types';
import { createAxiosClient, type RequestConfig, type ResponseConfig } from '../../utils/createAxiosClient';
import { getBaseUrl } from '../../utils/getBaseUrl';

export { type RequestConfig };
export type ResponseErrorConfig<TData = unknown> = ResponseConfig<TData>;

const baseUrl: BaseUrl = {
  production: 'https://api.pfida.com',
  development: 'https://api-dev.pfida.com',
};

const userBackendClient = createAxiosClient({
  baseURL: getBaseUrl(baseUrl),
  serviceName: 'USER_BACKEND',
});

export default userBackendClient;
